import { CircularProgress } from "@mui/material";
import DetailsPanel from "components/Elements/DetailsPanel";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { showError } from "../../../../redux/common/actions";
import { getUserSites } from "services/users/userSites";
import { getClientUserDetails } from "services/users/userDetails";
import UserSiteListTable from "./userSiteListTable";

function UserSite() {
	const { id } = useParams();

	const [sites, setSites] = useState([]);
	const [loading, setLoading] = useState(true);
	const [clientId, setClientId] = useState(null);

	const dispatch = useDispatch();
	const { t } = useTranslation();

	const fetchClientId = useCallback(async () => {
		try {
			const response = await getClientUserDetails(id);
			console.log("getClientUserDetails response:", response);
			if (response.status) {
				const extractedClientId = response.data?.clientID || response.data?.ClientID;
				console.log("Extracted clientId from user details:", extractedClientId);
				setClientId(extractedClientId);
			}
		} catch (error) {
			console.error("Error fetching client ID:", error);
		}
	}, [id]);

	const fetchUserSites = useCallback(async () => {
		try {
			const response = await getUserSites(id);
			console.log("getUserSites full response:", response);
			if (response.status) {
				console.log("Response data:", response.data);
				// Extract clientId from first item if not already set
				if (!clientId && response.data.length > 0) {
					console.log("First item:", response.data[0]);
					const firstClientId = response.data[0]?.clientID || response.data[0]?.ClientID;
					console.log("Extracted clientId:", firstClientId);
					if (firstClientId) {
						setClientId(firstClientId);
					}
				}
				
				setSites(
					response.data.reduce((sites, item, index) => {
						const mappedSites = item.sites;
						return [...mappedSites, ...sites];
					}, [])
				);
			} else {
				dispatch(
					showError(
						response?.data?.title || t("message.couldNotFetchUserSites")
					)
				);
			}
		} catch (error) {
			showError(error?.response?.detail || t("message.couldNotFetchUserSites"));
		} finally {
			setLoading(false);
		}
	}, [id, dispatch, t]);

	useEffect(() => {
		const fetchAllData = async () => {
			await fetchClientId();
			await fetchUserSites();
		};
		fetchAllData();
	}, [fetchClientId, fetchUserSites]);

	if (loading) return <CircularProgress />;

	return (
		<div>
			<div className="detailsContainer">
				<DetailsPanel
					header={t("label.sites")}
					description={t("message.manageSitesDescription")}
					dataCount={null}
				/>
			</div>
			<UserSiteListTable
				data={sites}
				clientUserID={id}
				fetchUserSites={fetchUserSites}
				clientId={clientId}
				columns={["name", "Department", "Active"]}
				headers={[
					{ id: 1, name: t("label.siteName"), width: "20vw" },
					{
						width: "40vw",
						id: 2,
						name: t("entity.department"),
					},
					{
						id: 3,
						name: t("label.active"),
						width: "10vw",
					},
				]}
			/>
		</div>
	);
}

export default UserSite;
